import {
    SquareMenu,
    Hospital,
    UserRoundKey,
    ChartNoAxesCombined,
    ShoppingCart,
    Menu,
    PawPrint,
    CalendarRange,
    Contact,
    ShieldPlus,
    ClipboardList,
    Users,
    HouseHeart,
    HandCoins,
    Wallet,
    Tag,
    BriefcaseMedical,
    ShoppingBasket,
    Ambulance,
    UserRoundCog,
    BanknoteArrowUp,
    Settings,
    Tickets,
    FileSearchCorner,
    Scissors,
    CalendarPlus,
    LogOut,
    AppWindow,
    UserStar,
    ImagePlay,
    FastForward,
    Warehouse
 } from 'lucide-vue-next';

 export const iconsMap = {
    SquareMenu,
    Hospital,
    UserRoundKey,
    ChartNoAxesCombined,
    ShoppingCart,
    Menu,
    PawPrint,
    CalendarRange,
    Contact,
    ShieldPlus,
    ClipboardList,
    Users,
    HouseHeart,
    HandCoins,
    Wallet,
    Tag,
    BriefcaseMedical,
    ShoppingBasket,
    Ambulance,
    UserRoundCog,
    BanknoteArrowUp,
    Settings,
    Tickets,
    FileSearchCorner,
    Scissors,
    CalendarPlus,
    LogOut,
    AppWindow,
    UserStar,
    ImagePlay,
    FastForward,
    Warehouse
};
